import styled from 'styled-components'

import { Colors, mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: ${Colors.GS200};
  padding: 12px 16px 16px;

  ${mediaQueries.tablet} {
    padding: 16px 20px;
  }
`

export const DomainName = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`

export const ConnectedButtonsWrapper = styled.div`
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;

  ${mediaQueries.tablet} {
    flex-direction: row;
  }
`
